import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from './locales/en/translation.json';
import translationFR from './locales/fr/translation.json';
import translationES from './locales/es/translation.json';
import translationAR from './locales/ar/translation.json';
import translationTA from './locales/ta/translation.json';
import translationHI from './locales/hi/translation.json';
import translationKN from './locales/kn/translation.json';
import translationML from './locales/ml/translation.json';
import translationTE from './locales/te/translation.json';

const resources = {
  en: { translation: translationEN },
  fr: { translation: translationFR },
  es: { translation: translationES },
  ar: { translation: translationAR },
  ta: { translation: translationTA },
  te: { translation: translationTE },
  ml: { translation: translationML },
  kn: { translation: translationKN },
  hi: { translation: translationHI }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export const normalizeKey = (name) => {
    if (!name) return '';
    // Removes spaces and converts to lowercase to match JSON keys
    return name.toLowerCase().replace(/\s/g, '_'); 
};

export default i18n;